// extracted by mini-css-extract-plugin
export var tosLink = "_ao-0";